// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"68f4cef95ca18c75c2a5","453":"b5130abdd4f815f792e0","522":"a19faf7276a178c34a45"}[chunkId] + ".js";
};